import React, { useState, useEffect } from 'react';

import { useToken } from '../../hooks/useToken';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const CountdownTimer = () => {
	const [isVisible, setIsVisible] = useState(false);

	const handleScroll = () => {
		if (window.scrollY > 390) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	};

	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll); // Cleanup on unmount
		};
	}, []);

	const { sessionTimer } = useToken();

	if (sessionTimer === 0) {
		return null;
	}

	const pad = (num, size) => {
		num = num.toString();
		while (num.length < size) num = '0' + num;
		return num;
	};

	return (
		<>
			{isVisible && (
				<IconButton
					className='filter'
					onClick={handleScrollToTop}
					sx={{
						position: 'fixed',
						bottom: { xs: '20px', sm: '30px', md: '60px' },
						right: { xs: '15px', sm: '30px', md: '60px' },
						border: (theme) => `2px solid ${theme.palette.secondary.main}`,
						zIndex: '99',
						color: 'primary',
						scale: { xs: '0.7', md: '1' },
						'&:hover': { opacity: '0.7' }
					}}
				>
					<ArrowUpwardIcon />
				</IconButton>
			)}
			<Stack
				sx={{
					background: (theme) => theme.palette.common.lightWhite,
					padding: '3px 0',
					borderRadius: '5px',
					width: {
						xs: '57px',
						md: '80px'
					},
					alignItems: 'center',
					fontSize: {
						xs: '0.8em',
						sm: '0.83em',
						md: '1em'
					}
				}}
			>
				<Stack direction='row' alignItems='center' gap='3px'>
					<Tooltip
						title={
							<Typography
								variant='body2'
								disableHoverListener
								disableFocusListener
								disableTouchListener={false}
							>
								Time remaining before session expires
							</Typography>
						}
					>
						<AccessTimeIcon
							sx={{
								verticalAlign: 'middle',
								fontSize: {
									xs: 12,
									md: 15
								},
								transform: 'translateY(-1px)'
							}}
						/>{' '}
						{Math.floor(sessionTimer / 60)}:
						{pad(sessionTimer - Math.floor(sessionTimer / 60) * 60, 2)}
					</Tooltip>
				</Stack>
			</Stack>
		</>
	);
};

CountdownTimer.propTypes = {};

export default CountdownTimer;
